var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignemnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 7.94332C5.66797 7.10577 6.34893 6.4248 7.18649 6.4248H10.9828V9.46184C10.9828 9.88181 11.3221 10.2211 11.742 10.2211H14.7791V13.2036L12.7196 15.2631C12.4752 15.5074 12.3044 15.8111 12.2213 16.1457L11.7776 17.9228C11.7231 18.1411 11.7349 18.3689 11.8085 18.5753H7.18649C6.34893 18.5753 5.66797 17.8944 5.66797 17.0568V7.94332ZM14.7791 9.46184H11.742V6.4248L14.7791 9.46184ZM18.713 12.0172L19.0547 12.3589C19.4248 12.729 19.4248 13.3293 19.0547 13.7018L18.3571 14.3994L16.6725 12.7148L17.3701 12.0172C17.7402 11.6471 18.3405 11.6471 18.713 12.0172ZM13.0684 16.3189L16.1339 13.2534L17.8185 14.938L14.753 18.0011C14.6557 18.0984 14.5347 18.1672 14.3995 18.2004L12.9735 18.5563C12.843 18.5896 12.7077 18.5516 12.6128 18.4567C12.5179 18.3618 12.4799 18.2265 12.5132 18.096L12.8691 16.6701C12.9023 16.5372 12.9711 16.4138 13.0684 16.3165V16.3189Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignemnt);
export default __webpack_public_path__ + "static/media/Assignemnt.fed36a2d464c98d5c540af814f416577.svg";
export { ForwardRef as ReactComponent };